import { Box } from '@mui/material';
import React from 'react';

export default function SpaceBox(props: {
  width?: number;
  height?: number;
  smWidth?: number;
  smHeight?: number;
}) {
  return (
    <Box
      sx={{
        width: { xs: props.width + 'px' || '100%', sm: props.smWidth + 'px' || '100%' },
        height: { xs: props.height + 'px' || '100%', sm: props.smHeight + 'px' || '100%' },
      }}
    />
  );
}
